<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Nhận xét môn học&nbsp;</span><breadcrumbs [items]="breadcrumbs"></breadcrumbs></div>
     <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button 
          class="flex items-center justify-center" 
          nz-button 
          nzTooltipTitle="Các cột điểm phải là số nguyên không lớn hơn 10" 
          nzTooltipPlacement="bottom" 
          nz-tooltip
          >
          <i 
            nz-icon 
            nzType="question-circle" 
            nzTheme="outline"
            >
          </i>
        </button>
        <button 
          class="flex items-center justify-center" 
          nz-button 
          nzTooltipTitle="Nhật ký" 
          nzTooltipPlacement="bottom" 
          nz-tooltip
          >
            <i 
              nz-icon
              nzType="field-time" 
              nzTheme="outline"
              >
            </i>
        </button>
          <nz-upload
            class="flex items-start"
            nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            [nzHeaders]="{ authorization: 'authorization-text' }"
            (nzChange)="handleChange($event)"
          >
            <button 
              nz-button 
              class="flex items-center justify-center" 
              nzTooltipTitle="Xuất excel" 
              nzTooltipPlacement="bottom" 
              nz-tooltip
              >
                <i 
                  nz-icon 
                  nzType="file-excel" 
                  nzTheme="twotone"
                  >
                </i>
            </button>
          </nz-upload>
          <button 
            class="flex items-center justify-center" 
            nz-button 
            nzTooltipTitle="In" 
            nzTooltipPlacement="bottom" 
            nz-tooltip
            >
              <i 
                nz-icon 
                nzType="printer" 
                nzTheme="outline"
                >
              </i>
          </button>
            <nz-upload
              class="flex items-start"
              nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              [nzHeaders]="{ authorization: 'authorization-text' }"
              (nzChange)="handleChange($event)"
              >
              <button 
                class="flex items-center justify-center" 
                nz-button 
                nzTooltipTitle="Import" 
                nzTooltipPlacement="bottom"
                nz-tooltip
                >
                  <i 
                    nz-icon 
                    nzType="export" 
                    nzTheme="outline"
                    >
                  </i>
              </button>
          </nz-upload>
          <button 
            class="flex items-center justify-center" 
            (click)="stopEdit()" 
            nz-button 
            nzType="primary" 
            nzTooltipTitle="Lưu điểm" 
            nzTooltipPlacement="bottom" 
            nz-tooltip
            (click)="save()"
            >
            <i 
              nz-icon 
              nzType="save"
              nzTheme="outline"
              >
            </i>
          </button>
          <div 
            class="verticalLine"
            >
          </div>
          <button 
            class="flex items-center justify-center" 
            [disabled]="!allowSyncTbl" 
            (click)="rowSync()" 
            nz-button 
            nzType="primary" 
            nzTooltipTitle="Đổi đồng bộ hàng ngang" 
            nzTooltipPlacement="bottom" 
            nz-tooltip
            >
            <i 
              nz-icon 
              nzType="arrow-left" 
              nzTheme="outline"
              >
            </i>
            <i 
              nz-icon 
              nzType="arrow-right" 
              nzTheme="outline"
              >
            </i>
          </button>
          <button 
            class="flex items-center justify-center" 
            [disabled]="!allowSyncTbl" 
            (click)="columnSync()" 
            nz-button 
            nzType="primary" 
            nzTooltipTitle="Đổi đồng bộ hàng dọc" 
            nzTooltipPlacement="bottom" 
            nz-tooltip
            >
            <i 
              nz-icon 
              nzType="arrow-down" 
              nzTheme="outline"
              >
            </i>
            <i 
              nz-icon 
              nzType="arrow-up" 
              nzTheme="outline"
              >
            </i>
          </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button 
          class="flex items-center justify-center" 
          nz-button 
          nzTooltipTitle="Các cột điểm phải là số nguyên không lớn hơn 10" 
          nzTooltipPlacement="bottom" 
          nz-tooltip
          >
          <i 
            nz-icon 
            nzType="question-circle" 
            nzTheme="outline"
            >
          </i>
        </button>
        <button 
          class="flex items-center justify-center" 
          nz-button 
          >Nhật ký
        </button>
          <nz-upload
            class="flex items-start"
            nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            [nzHeaders]="{ authorization: 'authorization-text' }"
            (nzChange)="handleChange($event)"
          >
            <button 
              nz-button 
              class="flex items-center justify-center" 
              >Xuất excel
            </button>
          </nz-upload>
          <button 
            class="flex items-center justify-center" 
            nz-button
            >In
          </button>
            <nz-upload
              class="flex items-start"
              nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              [nzHeaders]="{ authorization: 'authorization-text' }"
              (nzChange)="handleChange($event)"
              >
              <button 
                class="flex items-center justify-center" 
                nz-button 
                >Import
              </button>
          </nz-upload>
          <button 
            class="flex items-center justify-center" 
            (click)="stopEdit()" 
            nz-button 
            nzType="primary"
            (click)="save()"
            >Lưu điểm
          </button>
          <div 
            class="verticalLine mr-3"
            >
          </div>
          <button 
            class="flex items-center justify-center" 
            [disabled]="!allowSyncTbl" 
            (click)="rowSync()" 
            nz-button 
            nzType="primary" 
            >Đồng bộ hàng ngang
          </button>
          <button 
            class="flex items-center justify-center" 
            [disabled]="!allowSyncTbl" 
            (click)="columnSync()" 
            nz-button 
            nzType="primary" 
            nzTooltipTitle="Đổi đồng bộ hàng dọc" 
            nzTooltipPlacement="bottom" 
            nz-tooltip
            >Đồng bộ hàng dọc
          </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button 
          class="flex items-center justify-center" 
          nz-button 
          nzTooltipTitle="Các cột điểm phải là số nguyên không lớn hơn 10" 
          nzTooltipPlacement="bottom" 
          nz-tooltip
        >
          <i 
            nz-icon 
            nzType="question-circle" 
            nzTheme="outline"
            >
          </i>
        </button>
        <button 
          class="flex items-center justify-center" 
          nz-button
          >
            <i 
              nz-icon
              nzType="field-time" 
              nzTheme="outline"
              >
            </i>Nhật ký
        </button>
          <nz-upload
            class="flex items-start"
            nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            [nzHeaders]="{ authorization: 'authorization-text' }"
            (nzChange)="handleChange($event)"
          >
            <button 
              nz-button 
              class="flex items-center justify-center"
              >
                <i 
                  nz-icon 
                  nzType="file-excel" 
                  nzTheme="twotone"
                  >
                </i>Xuất excel
            </button>
          </nz-upload>
          <button 
            class="flex items-center justify-center" 
            nz-button
            >
              <i 
                nz-icon 
                nzType="printer" 
                nzTheme="outline"
                >
              </i>In
          </button>
            <nz-upload
              class="flex items-start"
              nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              [nzHeaders]="{ authorization: 'authorization-text' }"
              (nzChange)="handleChange($event)"
              >
              <button 
                class="flex items-center justify-center" 
                nz-button
                >
                  <i 
                    nz-icon 
                    nzType="export" 
                    nzTheme="outline"
                    >
                  </i>Import
              </button>
          </nz-upload>
          <button 
            class="flex items-center justify-center" 
            (click)="stopEdit()" 
            nz-button 
            nzType="primary"
            >
            <i 
              nz-icon 
              nzType="save"
              nzTheme="outline"
              (click)="save()"
              >
            </i>Lưu điểm
          </button>
          <div 
            class="verticalLine "
            >
          </div>
          <button 
            class="flex items-center justify-center" 
            [disabled]="!allowSyncTbl" 
            (click)="rowSync()" 
            nz-button 
            nzType="primary"
            >
            <i 
              nz-icon 
              nzType="arrow-left" 
              nzTheme="outline"
              >
            </i>
            <i 
              nz-icon 
              nzType="arrow-right" 
              nzTheme="outline"
              >
            </i>đồng bộ hàng ngang
          </button>
          <button 
            class="flex items-center justify-center" 
            [disabled]="!allowSyncTbl" 
            (click)="columnSync()" 
            nz-button 
            nzType="primary"
            >
            <i 
              nz-icon 
              nzType="arrow-down" 
              nzTheme="outline"
              >
            </i>
            <i 
              nz-icon 
              nzType="arrow-up" 
              nzTheme="outline"
              >
            </i>Đồng bộ hàng dọc
          </button>
        </ng-container>
      </div>
  </div>
  <form nz-form class="ant-advanced-search-form" [formGroup]="validateForm" (ngSubmit)="submitForm()" (click)="stopEdit()" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="khoiLop">Khối lớp</nz-form-label>
          <nz-form-control [nzSpan]="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-select formControlName="khoiLop" ngModel="khoiLop" nzAllowClear nzPlaceHolder="Choose">
              <nz-option nzValue="10" nzLabel="10"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="lopHoc">Lớp học</nz-form-label>
          <nz-form-control [nzSpan]="24" nzHasFeedback nzValidatingTip="Validating..." nzErrorTip="vui lòng chọn lớp học!">
            <nz-select class="w-full" formControlName="lopHoc" ngModel="lopHoc" nzAllowClear nzPlaceHolder="Choose">
              <nz-option nzValue="10A1" nzLabel="10A1"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="6" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="monHoc">Môn học</nz-form-label>
          <nz-form-control [nzSpan]="24" nzHasFeedback nzValidatingTip="Validating..." nzErrorTip="vui lòng chọn môn học!">
            <nz-select class="w-full" formControlName="monHoc" ngModel="monHoc" nzAllowClear nzPlaceHolder="Choose">
              <nz-option nzValue="toan" nzLabel="Toán"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i>
          </button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'">Tìm kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()"
          nzTooltipTitle="Xóa tìm kiếm" 
          nzTooltipPlacement="bottom" 
          nz-tooltip
          ><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'" 
            nzTooltipTitle="Tìm kiếm" 
            nzTooltipPlacement="bottom" 
            nz-tooltip><i nz-icon nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search" nzTheme="outline" ></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table 
      #groupingTable 
      nzFrontPagination="false" 
      [nzData]="listOfData" 
      nzOuterBordered 
      nzSize="small" 
      [nzScroll]="{x: width + 'px' }" 
      class="absolute w-full">
      <thead>
        <tr (click)="stopEdit()" #pageHeaderTable>
          <th rowspan="2" nzWidth="50px" nzLeft>STT</th>
          <th rowspan="2" nzWidth="200px" nzLeft>Mã Học sinh</th>
          <th rowspan="2" nzWidth="200px" nzLeft>Họ đệm</th>
          <th rowspan="4" nzWidth="100px" nzLeft [nzSortFn]="sortNameFn">Tên</th>
          <th colspan="7">Nhận xét kiểm tra thường xuyên</th>
          <th colspan="2">Nhận xét kiểm tra định kỳ</th>
          <th rowspan="2" nzRight>Nhận xét KT HK</th>
          <th rowspan="2" nzRight>Nhận xét Học Kỳ</th>
          <th rowspan="2" nzRight>Nhận xét TB</th>
        </tr>
        <tr (click)="stopEdit()" #pageHeaderTable2>
          <th nzWidth="100px">M1</th>
          <th>M2</th>
          <th>M3</th>
          <th>P1</th>
          <th>P2</th>
          <th>P3</th>
          <th>P4</th>
          <th>V1</th>
          <th>V2</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of groupingTable.data  ; let i = index">
          <td nzLeft>{{ data.stt }}</td>
          <td nzLeft>{{ data.maHS }}</td>
          <td nzLeft>{{ data.hoDem }}</td>
          <td nzLeft>{{ data.ten }}</td>
          <td [style.border]="isFocus(i, 0) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 0)" (click)="startEdit(i, 0, data.stt, 'm1')">
              {{ data.m1 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 0)" [(ngModel)]="data.m1" >
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
          <td [style.border]="isFocus(i, 1) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 1)" (click)="startEdit(i, 1, data.stt, 'm2')">
              {{ data.m2 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 1)" [(ngModel)]="data.m2" (blur)="stopEdit()">
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>
          <td [style.border]="isFocus(i, 2) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 2)" (click)="startEdit(i, 2,data.stt , 'm3')">
              {{ data.m3 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 2)" [(ngModel)]="data.m3" (blur)="stopEdit()">
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>
          <td [style.border]="isFocus(i, 3) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 3)" (click)="startEdit(i, 3,data.stt, 'p1')">
              {{ data.p1 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 3)" [(ngModel)]="data.p1" (blur)="stopEdit()">
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>
          <td [style.border]="isFocus(i, 4) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 4)" (click)="startEdit(i, 4,data.stt, 'p2')">
              {{ data.p2 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 4)" [(ngModel)]="data.p2" (blur)="stopEdit()">
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>
          <td [style.border]="isFocus(i, 5) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 5)" (click)="startEdit(i, 5, data.stt, 'p3')">
              {{ data.p3 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 5)" [(ngModel)]="data.p3" (blur)="stopEdit()">
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>
          <td [style.border]="isFocus(i, 6) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 6)" (click)="startEdit(i, 6, data.stt,'p4')">
              {{ data.p4 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 6)" [(ngModel)]="data.p4" (blur)="stopEdit()">
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>
          <td [style.border]="isFocus(i, 7) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 7)" (click)="startEdit(i, 7,data.stt, 'v1')">
              {{ data.v1 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 7)" [(ngModel)]="data.v1" (blur)="stopEdit()">
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>
          <td [style.border]="isFocus(i, 8) ? '1px solid #1890ff' : ''">
            <div class="editable-cell" [hidden]="isFocus(i, 8)" (click)="startEdit(i, 8,data.stt, 'v2')">
              {{ data.v2 }}
            </div>
              <nz-select #selects [hidden]="!isFocus(i, 8)" [(ngModel)]="data.v2" (blur)="stopEdit()">
                <nz-option nzValue="CNX" nzLabel="CNX"></nz-option>
                <nz-option nzValue="CĐ" nzLabel="CĐ"></nz-option> 
                <nz-option nzValue="Đ" nzLabel="Đ"></nz-option>
              </nz-select>
          </td>
          <td nzRight>{{ data.diemtkhk }}</td>
          <td nzRight>{{ data.tamtinhdtb }}</td>
          <td nzRight>{{ data.dtb }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>